module Meevo.Plugins.ProductBundles {
    "use strict";
    enum AssemblyTypeEnum {
        Assemble,
        Disassemble
    }


    /**
    * Main Section
    */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ProductBundle> {
        private isSkuValid: boolean;
        private isBarCodeValid: boolean;
        public productVariantInCustomBundles = [];
        /**
        * Base class override which defines what a DEFAULT model looks like.
        */
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = data;
                this.model.discountPercentage = 0;
            });
        }
        isSkuLengthValid(sku): void {
            if (this.model) {
                if (sku && sku.length <= 30)
                    this.isSkuValid = true;
                else
                    this.isSkuValid = false;
            }
        }
        isBarCodeLengthValid(barCode): void {
            if (this.model) {
                if (barCode && barCode.length <= 20)
                    this.isBarCodeValid = true;
                else
                    this.isBarCodeValid = false;
            }
            else
                this.isBarCodeValid = false;
        }
        preventSkuWriting(isSku, type, event): void {
            if (isSku) {
                if (type && type.length >= 30)
                    event.preventDefault();
                else if (type && type.length <= 30)
                    this.isSkuValid = true;
            }
            else{
             if (type && type.length >= 20) 
                    event.preventDefault();
             else if (type && type.length <= 20)
                 this.isBarCodeValid = true;
            }
        }

        sectionModelRetrieved() {
            var customBundle = this.model;
            if (customBundle!=undefined && customBundle.isCustomProductBundle && customBundle.customBundleGroups != undefined) {
                customBundle.customBundleGroups.forEach(g => {
                    if (g.customProductVariantBundles != undefined) {
                        g.customProductVariantBundles.forEach(cp => {
                            this.productVariantInCustomBundles.push(cp);
                        });
                    }
                });
            }
        }
        addCustomBundleGroup() {
            var customBundle = this.model;
            if (customBundle === undefined || customBundle.customBundleGroups === undefined) {
                customBundle.customBundleGroups = [];
            }

            if (!this.isReadonly) {
                customBundle.customBundleGroups.push({
                    customBundleGroupId: Guid.newSqlSequentialGuid()["guid"],
                    requiredQuantity: 1,
                    customProductVariantBundle: null,
                    customProductVariantBundles: []

                });
            }
        }
        addProductVariantToCustomeBundle(id: Guid) {
            var customBundle = this.model;
            if (customBundle === undefined || customBundle.customBundleGroups === undefined)
                return;

            var group = customBundle.customBundleGroups.find(g => g.customBundleGroupId.equals(id));
            if (_.find(group != undefined && group.customProductVariantBundle != undefined
                && group.customProductVariantBundles, (vb) => {
                    return vb.displayName === group.customProductVariantBundle.displayName;
                }) === undefined) {
                {

                    group.customProductVariantBundles.push({
                        id: group.customProductVariantBundle.id,
                        displayName: group.customProductVariantBundle.displayName,
                        retail: group.customProductVariantBundle.retail,
                        quantity: 1
                       
                    });                    
                    this.productVariantInCustomBundles.push(group.customProductVariantBundle);                    
                    customBundle.variantBundles.push(
                        {
                            id: group.customProductVariantBundle.id,
                            retail: group.customProductVariantBundle.retail,
                            quantity: 1
                        });
                    group.customProductVariantBundle = undefined;
                }
            }            
        }
        removeProductVariantFromCustomBundleGroup(id: Guid, index: number) {
            var customBundle = this.model;
            if (customBundle === undefined || this.isReadonly || customBundle == null)
                return;
            var deletedVariant = customBundle.customBundleGroups.find(g => g.customBundleGroupId.equals(id)).customProductVariantBundles.splice(index, 1);
            if (deletedVariant != undefined && !_.isEmpty(deletedVariant)) {
                var variant = deletedVariant[0];
                if (variant != undefined) {
                    this.productVariantInCustomBundles = this.productVariantInCustomBundles.filter(v => v.id != variant.id);
                }
            }
        }
        removeCustomBundleGroup(index: number) {
            var customBundle = this.model;
            if (customBundle === undefined || this.isReadonly || customBundle == null)
                return;
            if (!_.isEmpty(customBundle.customBundleGroups)) {
                //code: to remove from the array list to exclude the variants

                customBundle.customBundleGroups.splice(index, 1);
            }

        }
    }
}